import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Appraisal, ApprovalList, EvaluationReport } from 'src/app/shared/models/appraisal';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { EvaluationSlipComponent } from '../evaluation-slip/evaluation-slip.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-evaluation-report',
  templateUrl: './evaluation-report.component.html',
  styleUrls: ['./evaluation-report.component.scss']
})
export class EvaluationReportComponent implements OnInit {
  public appraisals: Appraisal[] = [];
  public approvals: EvaluationReport[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public activeAppraisalId: number | null = null;
  public applicable: boolean;
  public evaluation: boolean;
  public promotable: boolean;
  public context: Context;

  constructor(
    private commonService: CommonService,
    private dataService: DataService,
    private appraisalService: ApparaisalService,
    private modalService: NgbModal,
    private authService:AuthService
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.appraisalService.getAppraisals().subscribe((appraisals: Appraisal[]) => {
      this.appraisals = appraisals;
      this.activeAppraisalId = this.appraisals.find(appraisal => appraisal.active)?.id;
      this.getApprovals();
    });
  }

  public getTruncatedName(name: string, maxLength: number): string {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  }

  private getApprovals(clear: boolean = true) {
    if (this.activeAppraisalId) {
      if (clear) {
        this.isLoading = true;
        this.approvals = [];
      }
      this.appraisalService.getEvaluationReport(this.context?.employeeId,this.activeAppraisalId, this.applicable, this.promotable, this.evaluation).subscribe({
        next: (approvals: EvaluationReport[]) => {
          this.approvals = approvals;
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public onStatusChange() {
    this.getApprovals();
  }

  public processPayment(payment?: EvaluationReport) {
    if (!this.privilege.canEdit) return;
    let modalRef = this.modalService.open(EvaluationSlipComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.activeAppraisalId = this.activeAppraisalId;
    modalRef.componentInstance.context = this.context;
    modalRef.componentInstance.assessmentData =payment;
    modalRef.result.then((response: ApprovalList) => {
    })
      .catch((error) => {
      });
  }
}
